export default "__VITE_ASSET__CeePk0Xf__"